module.exports = __webpack_public_path__ + "img/detail_portrait_default_man@2x.dfcac7ea.png";